import { ISelectOption } from '@salecycle/ui-component-library';

export const compare = (labelA: string | number, labelB: string | number): number => {
  let comparison = 0;
  if (labelA > labelB) {
    comparison = 1;
  } else if (labelA < labelB) {
    comparison = -1;
  }
  return comparison;
};

/** Sorts the options (`ISelectOption`) by the `label` value. */
export const sortOptions = (a: ISelectOption<string>, b: ISelectOption<string>): number => {
  return compare(a.label.toLowerCase(), b.label.toLowerCase());
};
